import { z } from 'zod';

const toRequiredNumber = (val: unknown) =>
  val === '' || val === undefined || val === null ? undefined : Number(val);

export const createResaleItemFormSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  vendor: z.string().min(1, 'Vendor is required'),
  max_quantity: z.preprocess(
    toRequiredNumber,
    z.number({ invalid_type_error: 'Daily limit is required' }).int().nonnegative()
  ),
  recommended_retail_price: z.preprocess(
    toRequiredNumber,
    z.number({ invalid_type_error: 'Retail price is required' }).nonnegative()
  ),
  cost_to_company: z.preprocess(
    toRequiredNumber,
    z.number({ invalid_type_error: 'Cost price is required' }).nonnegative()
  ),
  item_notes: z.string().nullable().optional(),
  delivery_details: z.string().nullable().optional(),
});

export type CreateResaleItemFormData = z.infer<typeof createResaleItemFormSchema>;

export const updateResaleItemFormSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  vendor: z.string().min(1, 'Vendor is required'),
  max_quantity: z.preprocess(
    toRequiredNumber,
    z.number({ invalid_type_error: 'Daily limit is required' }).int().nonnegative()
  ),
  recommended_retail_price: z.preprocess(
    toRequiredNumber,
    z.number({ invalid_type_error: 'Retail price is required' }).nonnegative()
  ),
  cost_to_company: z.preprocess(
    toRequiredNumber,
    z.number({ invalid_type_error: 'Cost price is required' }).nonnegative()
  ),
  item_notes: z.string().nullable().optional(),
  delivery_details: z.string().nullable().optional(),
  // Bumped when images are added/removed so the form's isDirty flag captures image changes.
  _imageVersion: z.number().default(0),
});

export type UpdateResaleItemFormData = z.infer<typeof updateResaleItemFormSchema>;
